export default "__VITE_ASSET__Cb5CW9gV__"